export default {
  name: 'Default-light',
  dark: false,
  scheme: 'md-backoffice-scheme',
  primary: '#cca256'
}
